module.exports = __webpack_public_path__ + "img/narcisa.48ba512b.png";